/**
 * Capture document patches — always use updateDoc with field paths.
 * Do NOT use setDoc(..., { merge: true }) with dotted keys; Firestore stores them
 * as literal root fields (e.g. "processing.status") instead of nested maps.
 */
import { updateDoc } from 'firebase/firestore';

export async function patchCaptureDoc(captureRef, patch) {
  if (!captureRef || !patch || Object.keys(patch).length === 0) return;
  await updateDoc(captureRef, patch);
}
